import React from 'react';

import AttributeMappingComponent from './component/AttributeMapping/AttributeMapping';
import type { AttributeMappingProps } from './data-layer/types';

/**
 * Main AttributeMapping component - public interface
 */
function AttributeMapping(props: AttributeMappingProps) {
  const {
    config,
    initialMappings,
    mandatoryMappings,
    onMappingsChange,
    onSave,
    disabled,
    showSaveButton,
    className,
  } = props;

  return (
    <AttributeMappingComponent
      config={config}
      initialMappings={initialMappings}
      mandatoryMappings={mandatoryMappings}
      onMappingsChange={onMappingsChange}
      onSave={onSave}
      disabled={disabled}
      showSaveButton={showSaveButton}
      className={className}
    />
  );
}

export default AttributeMapping;
